import React, { useState, useContext } from 'react';
import styles from './DateNavigation.module.scss';
import { CircleArrowLeft, CircleArrowRight } from 'lucide-react';

const DateNavigation = ({ period, setPeriod, date, setDate, setDateRange }) => {

    const goToPreviousPeriod = () => {
    const newDate = new Date(date); // clone pour ne pas muter
    switch (period) {
        case 'day':
            newDate.setDate(newDate.getDate() - 1);
            break;
        case 'week':
            newDate.setDate(newDate.getDate() - 7);
            break;
        case 'month':
            newDate.setMonth(newDate.getMonth() - 1);
            break;
        case 'year':
            newDate.setFullYear(newDate.getFullYear() - 1);
            break;
        default:
            break;
        }
        setDate(newDate);
    };


    const goToNextPeriod = () => {
        const newDate = new Date(date); // clone
        switch (period) {
        case 'day':
            newDate.setDate(newDate.getDate() + 1);
            break;
        case 'week':
            newDate.setDate(newDate.getDate() + 7);
            break;
        case 'month':
            newDate.setMonth(newDate.getMonth() + 1);
            break;
        case 'year':
            newDate.setFullYear(newDate.getFullYear() + 1);
            break;
        default:
            break;
        }
        setDate(newDate);
    };

    const getDateRangeLabel = () => {
        const end = new Date(date);
        const start = new Date(date);

        switch (period) {
        case 'day':
            break; // start et end sont déjà identiques
        case 'week':
            const day = start.getDay(); // 0 = dimanche, 1 = lundi, ..., 6 = samedi
            const diffToMonday = (day === 0 ? -6 : 1 - day); // dimanche → -6, mardi → -1, lundi → 0
            start.setDate(start.getDate() + diffToMonday); // aller au lundi
            end.setTime(start.getTime() + 6 * 24 * 60 * 60 * 1000); // ajoute 6 jours exacts en ms
            break;
        case 'month':
            start.setDate(1);
            end.setMonth(end.getMonth() + 1, 0); // dernier jour du mois
            break;
        case 'year':
            start.setMonth(0, 1); // 1er janvier
            end.setMonth(11, 31); // 31 décembre
            break;
        default:
            break;
        }

        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const startStr = start.toLocaleDateString('fr-FR', options);
        const endStr = end.toLocaleDateString('fr-FR', options);

        setDateRange(startStr !== endStr ? `du ${startStr} au ${endStr}` : `journée du ${startStr}`);
    };



  return (
    <div className={styles.dateNav}>
        <p className={styles.subtitle}>{getDateRangeLabel(period, date)}</p>
        <div className={styles.controls}>
            <button onClick={goToPreviousPeriod} className={styles.backButton}>
            <CircleArrowLeft />
            </button>

            <select
            className={styles.select}
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            >
            <option value="day">Journée</option>
            <option value="week">Semaine</option>
            <option value="month">Mois</option>
            <option value="year">Année</option>
            {/* <option value="all">Global</option> */}
            </select>

            <button onClick={goToNextPeriod} className={styles.nextButton}>
            <CircleArrowRight />
            </button>
        </div>
    </div>
  );
};

export default DateNavigation;
